var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNews = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4166 5.50286H8.24994V4.58008H17.4166V5.50286Z",
    fill: "#B41730"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.24994 7.33008H17.4166V8.25286H8.24994V7.33008Z",
    fill: "#B41730"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4166 11.0029H8.24994V10.0801H17.4166V11.0029Z",
    fill: "#B41730"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8333 13.7529H8.24994V12.8301H12.8333V13.7529Z",
    fill: "#B41730"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.49687 1.83008H20.1696V17.8748C20.1696 19.1437 19.1438 20.1695 17.8749 20.1695H4.12492C2.85604 20.1695 1.8302 19.1437 1.8302 17.8748V4.58008H5.49687V1.83008ZM6.41964 2.75286V5.50286H2.75298V17.8748C2.75298 18.634 3.36568 19.2467 4.12492 19.2467H17.8749C18.6342 19.2467 19.2469 18.634 19.2469 17.8748V2.75286H6.41964Z",
    fill: "#B41730"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.41966 5.0415V17.8748C6.41966 19.1437 5.39382 20.1696 4.12494 20.1696V19.2468C4.88418 19.2468 5.49688 18.6341 5.49688 17.8748V5.0415H6.41966Z",
    fill: "#B41730"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNews);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/news.ae39fe981f98fbc3406ab9a0e8912d98.svg";